const BREAKPOINTS = {
  DESKTOP_WIDTH_BREAKPOINT: 800,
};

export default BREAKPOINTS;
